import { CheckCircleIcon, ClockIcon } from "@cpj-ai/panel-npm-package";
import { AuthAccountJobPositionAssignmentStatusHistoryStatusChoices } from "@graphql/generated";
import { semanticColors } from "@heroui/react";
import SelectInterviewDateAction from "./actions";
import { StatusConfigs } from "./types";

export const BASE_CONFIG: StatusConfigs = {
  [AuthAccountJobPositionAssignmentStatusHistoryStatusChoices.NOT_REVIEWED]: {
    title: "Application Submitted",
    content: "Application has been sent and is awaiting initial review",
    icon: <CheckCircleIcon className="w-6 h-6" stroke={semanticColors.light.success[600]} />,
    status: "success",
  },
  [AuthAccountJobPositionAssignmentStatusHistoryStatusChoices.AWAITING_INTERVIEW_DATE]: {
    title: "Awaiting Interview Date",
    content: "Select interview date and time ",
    icon: <ClockIcon className="w-6 h-6" fill={semanticColors.light.warning[600]} />,
    action: <SelectInterviewDateAction />,
    status: "warning",
  },
  [AuthAccountJobPositionAssignmentStatusHistoryStatusChoices.INTERVIEW_SCHEDULED]: {
    title: "Interview Scheduled",
    content: "Interview has been successfully scheduled",
    icon: <CheckCircleIcon className="w-6 h-6" stroke={semanticColors.light.success[600]} />,
    status: "success",
  },
  [AuthAccountJobPositionAssignmentStatusHistoryStatusChoices.INTERVIEW_DONE]: {
    title: "Interview Done",
    content: "Interview completed, waiting for final evaluation",
    icon: <CheckCircleIcon className="w-6 h-6" stroke={semanticColors.light.success[600]} />,
    status: "success",
  },
  [AuthAccountJobPositionAssignmentStatusHistoryStatusChoices.INTERVIEW_CANCELED]: {
    title: "Interview Canceled",
    content: "Interview was canceled",
    icon: <CheckCircleIcon className="w-6 h-6" stroke={semanticColors.light.primary[600]} />,
    status: "error",
  },
  [AuthAccountJobPositionAssignmentStatusHistoryStatusChoices.REJECTED]: {
    title: "Application Rejected",
    content: "Application has been rejected",
    icon: <CheckCircleIcon className="w-6 h-6" stroke={semanticColors.light.primary[600]} />,
    status: "error",
  },
  [AuthAccountJobPositionAssignmentStatusHistoryStatusChoices.ACCEPTED]: {
    title: "Hired",
    content: "Candidate has been successfully hired for the position",
    icon: <CheckCircleIcon className="w-6 h-6" stroke={semanticColors.light.success[600]} />,
    status: "success",
  },
  [AuthAccountJobPositionAssignmentStatusHistoryStatusChoices.AWAITING_JOBSEEKER_APPROVAL]: {
    title: "Awaiting Job Seeker Approval",
    content: "Application has been received and is awaiting job seeker approval",
    icon: <CheckCircleIcon className="w-6 h-6" stroke={semanticColors.light.warning[600]} />,
    status: "warning",
  },
  [AuthAccountJobPositionAssignmentStatusHistoryStatusChoices.REJECTED_BY_JOBSEEKER]: {
    title: "Rejected by Job Seeker",
    content: "Application has been rejected by the job seeker",
    icon: <CheckCircleIcon className="w-6 h-6" stroke={semanticColors.light.primary[600]} />,
    status: "error",
  },
};
